export default __webpack_public_path__ + "static/media/card.055afa5a.jpg";